"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const react_router_1 = require("react-router");
const currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
const Input_1 = __importDefault(require("@mui/material/Input"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const KeyboardArrowRightRounded_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRightRounded"));
const core_1 = require("companion-app-components/utils/core");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const budgetsTypes_1 = require("companion-app-components/flux/budgets/budgetsTypes");
const budgetsActions = __importStar(require("companion-app-components/flux/budgets/budgetsActions"));
const compose_1 = __importDefault(require("utils/compose"));
const QProgressBar_1 = __importDefault(require("components/QProgressBar/QProgressBar"));
const QCurrency_1 = __importDefault(require("components/QCurrency"));
const Dump_1 = __importDefault(require("components/Dump"));
const inputFontSize = 13;
const styles = (theme) => ({
    input: Object.assign(Object.assign({}, theme.typography.body2), { fontSize: inputFontSize, width: 100, height: 20, '& input': {
            minHeight: 9,
            padding: '0 2px 0',
            MozAppearance: 'textfield',
            '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
            },
        } }),
    inputAdornment: Object.assign(Object.assign({}, theme.typography.body2), { fontSize: `${inputFontSize}px !important`, marginRight: 0 }),
});
const useStyles = (0, mui_1.makeStyles)()(styles);
const BudgetNode = ({ node, showChildLink, editInPlace, budget, isParent, index, formatAmount, style }) => {
    const [budgetNodeStates, setBudgetNodeStates] = (0, react_1.useState)({
        nodeState: undefined,
        userTargetAmount: undefined,
    });
    const { nodeState, userTargetAmount } = budgetNodeStates;
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_1.useNavigate)();
    const { classes, theme } = useStyles();
    const updateBudgetItem = (0, react_1.useCallback)(() => {
        if (!Number.isNaN(userTargetAmount) && nodeState && nodeState.negate) {
            const newTargetAmount = Number(userTargetAmount) * nodeState.negate;
            if (!Number.isNaN(newTargetAmount) && nodeState.targetAmount !== newTargetAmount) {
                const budgetItem = nodeState.budgetItems && nodeState.budgetItems.size === 1 ?
                    nodeState.budgetItems.first() : null;
                if (budgetItem) {
                    core_1.tracker.track(core_1.tracker.events.editBudget, { range: 'current_month' });
                    // @ts-expect-error: Argument of type '{ id: any; amount: number; }' is not assignable to parameter of type 'void'.
                    dispatch(budget_items_1.budgetItemsActions.updateBudgetItem({
                        id: budgetItem.id,
                        amount: newTargetAmount,
                    }, { undo: { userMessage: 'Budget target updated.' } }));
                    // QWIN refresh budget items only when budget updated
                    // TODO Dummy budget update call. tobe removed later once QWIN fixes the issue.
                    dispatch(budgetsActions.updateBudgetAction(budget));
                }
            }
            setBudgetNodeStates({
                nodeState: undefined,
                userTargetAmount: undefined,
            });
        }
    }, [userTargetAmount, nodeState, dispatch, budget]);
    const getProgressBarColor = (isIncome, targetAmount, temp) => {
        const amountLeft = Number.isNaN(temp) ? 0 : Number(temp);
        let overBudget = false;
        if (isIncome && targetAmount < 0 && amountLeft > 0)
            overBudget = true;
        else if (!isIncome && targetAmount >= 0 && amountLeft < 0)
            overBudget = true;
        return overBudget ? theme.palette.status.highMain : theme.palette.success.main;
    };
    const getAmountLeft = (showCents, targetTotalAmount, actualAmount) => {
        if (showCents) {
            return targetTotalAmount - actualAmount;
        }
        return targetTotalAmount - Math.round(actualAmount);
    };
    const { currency, showCents } = budget;
    const currencySymbol = (0, currency_symbol_map_1.default)(currency || 'N/A') || '';
    const isIncome = node.negate > 0;
    const actualAmount = !Number.isNaN(node.actualAmount) ? node.actualAmount * node.negate : undefined;
    const targetAmount = !Number.isNaN(node.targetAmount) ? node.targetAmount * node.negate : undefined;
    const rolloverAmount = !Number.isNaN(node.rolloverAmount) && !Number.isNaN(node.negate) ? node.rolloverAmount * node.negate : 0;
    const targetTotalAmount = !Number.isNaN(targetAmount) ? targetAmount + rolloverAmount : undefined;
    const amountLeft = !Number.isNaN(targetTotalAmount) && !Number.isNaN(actualAmount) ? getAmountLeft(showCents, targetTotalAmount, actualAmount) : undefined;
    const showLabelAmount = !editInPlace || node.type === budgetsTypes_1.BudgetNodeTypes.GROUP || node.type === budgetsTypes_1.BudgetNodeTypes.CATEGORY_ROLL_UP;
    const baseLink = '/budgets';
    let navLink = `${baseLink}?displayBudget=${budget.id}`;
    if (showChildLink) {
        navLink = `${navLink}&displayNode=${node.key}`;
    }
    let progressLabel;
    let value = null;
    let total = null;
    if (!Number.isNaN(actualAmount)) {
        value = showCents ? actualAmount : Math.round(actualAmount);
    }
    if (!Number.isNaN(targetAmount)) {
        total = showCents ? targetAmount : Math.round(targetAmount);
    }
    if (value * total > 0) {
        progressLabel =
            showCents ?
                `${Math.round((actualAmount / targetAmount) * 100)}%` :
                `${Math.round((Math.round(actualAmount) / Math.round((targetAmount))) * 100)}%`;
    }
    else {
        progressLabel = '';
    }
    return (<div role="presentation" style={Object.assign(Object.assign({}, style), { width: '100%', cursor: 'pointer', position: 'relative' })} key={node.key} onClick={() => {
            if (showChildLink) {
                navigate(navLink, { replace: true });
            }
            else if (isParent && node.children && node.children.size > 0) {
                navigate(baseLink, { replace: true });
            }
        }}>
      <Dump_1.default obj={node}/>
      <Typography_1.default id={`budgets-heading-${index}`} variant="body2" style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: inputFontSize,
            fontWeight: 500,
        }}>
        {`${node.displayLabel.toUpperCase()}`}
        {node.children && node.children.size > 0 &&
            <KeyboardArrowRightRounded_1.default id={`budgets-drill-down-arrow-${index}`}/>}
      </Typography_1.default>

      <span style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
        }}>
        <span>
          <Typography_1.default id={`budgets-actual-amount-heading-${index}`} variant="body2" style={{ display: 'inline-block', fontSize: inputFontSize, transform: showLabelAmount ? 'none' : 'translateY(-3px)' }}>
            {`${!Number.isNaN(actualAmount) && formatAmount(actualAmount, currency, !showCents)} of`}
            &nbsp;
          </Typography_1.default>

          {showLabelAmount ?
            <Typography_1.default id={`budgets-target-ro-amount-heading-${index}`} variant="body2" style={{ display: 'inline', fontSize: inputFontSize }}>
              {formatAmount(targetAmount, currency, !showCents)}
            </Typography_1.default>
            :
                <FormControl_1.default>
              <Input_1.default id={`budgets-target-amount-heading-${index}`} className={classes.input} inputProps={{ 'aria-label': 'budget target amount' }} value={nodeState && nodeState.key === node.key && !Number.isNaN(userTargetAmount) ?
                        userTargetAmount
                        :
                            (!Number.isNaN(targetAmount) && (targetAmount === null || targetAmount === void 0 ? void 0 : targetAmount.toFixed(showCents ? 2 : 0)))} onChange={(event) => {
                        setBudgetNodeStates({
                            nodeState: node,
                            userTargetAmount: event.target.value,
                        });
                    }} onKeyUp={(event) => {
                        if (event.key === 'Enter') {
                            updateBudgetItem();
                        }
                        event.stopPropagation();
                    }} onClick={(event) => event.stopPropagation()} type="number" startAdornment={<InputAdornment_1.default position="start" classes={{
                            root: classes.inputAdornment,
                        }} disableTypography>
                    {currencySymbol}
                  </InputAdornment_1.default>} onBlur={updateBudgetItem}/>
            </FormControl_1.default>}

          {!Number.isNaN(rolloverAmount) && rolloverAmount !== 0 &&
            <Typography_1.default id={`budgets-rollover-amount-${index}`} variant="body2" style={{ display: 'inline' }}>
            {` ${rolloverAmount >= 0 ? '+' : '-'} ${formatAmount(Math.abs(rolloverAmount), currency, !showCents)} (rollover)`}
          </Typography_1.default>}
        </span>

        <Typography_1.default id={`budgets-amount-over-or-left-${index}`} variant="body2" style={{ display: 'inline', fontSize: inputFontSize }}>
          {!Number.isNaN(amountLeft) && amountLeft * (targetAmount || +1) < 0 ?
            `${formatAmount(Math.abs(amountLeft), currency, !showCents)} Over` :
            `${formatAmount(Math.abs(amountLeft), currency, !showCents)} Left`}
        </Typography_1.default>
      </span>

      <QProgressBar_1.default id={`budgets-percentage-${index}`} value={value} total={total} color={getProgressBarColor(isIncome, targetAmount, amountLeft)} height={20} noShadow noRoundCorners backgroundColor={theme.palette.background.subtle} text={progressLabel}/>

    </div>);
};
exports.default = (0, compose_1.default)((0, QCurrency_1.default)())(BudgetNode);
